import React, { useEffect, useState } from 'react'
import { AiFillHeart, AiOutlineShoppingCart } from 'react-icons/ai'
import { Link, useNavigate } from 'react-router-dom'
import { FaEye } from 'react-icons/fa'
import Ratings from '../Ratings'
import toast from 'react-hot-toast'
import { useDispatch, useSelector } from 'react-redux'
import { Button } from "../../components/ui/button";
import { Heart, ShoppingBag, Package, Trophy } from 'lucide-react';
import { add_to_card, delete_card_product, messageClear, add_to_wishlist, remove_wishlist } from '../../store/reducers/cardReducer'
import { formatCurrency } from "../../utils/currencyUtils"
import { useCurrency } from "../../hooks/useCurrency"
const ShopProducts = ({ styles, products }) => {

    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { currencyCode, exchangeLoaded } = useCurrency()
    const { userInfo } = useSelector(state => state.auth)
    const { successMessage, errorMessage, wishlist, card_products, cart_product_ids } = useSelector(state => state.card)
    const toggle_cart = (p) => {
        if (!userInfo) { navigate('/login'); return; }
        const pid = p._id?.toString();
        if (cart_product_ids.includes(pid)) {
            const cartItem = card_products.flatMap(g => g.products || []).find(item => item.productInfo?._id?.toString() === pid);
            if (cartItem) dispatch(delete_card_product(cartItem._id));
        } else {
            dispatch(add_to_card({ userId: userInfo.id, quantity: 1, productId: p._id }));
        }
    }
    useEffect(() => {
        if (successMessage) {
            toast.success(successMessage)
            dispatch(messageClear())
        }
        if (errorMessage) {
            toast.error(errorMessage)
            dispatch(messageClear())
        }
    }, [errorMessage, successMessage])

    const toggle_wishlist = (pro) => {
        if (!userInfo) { navigate('/login'); return; }
        const existing = wishlist.find(w => w.productId === pro._id.toString() || w.productId === pro._id);
        if (existing) {
            dispatch(remove_wishlist(existing._id));
        } else {
            dispatch(add_to_wishlist({
                userId: userInfo.id,
                productId: pro._id,
                name: pro.name,
                price: pro.price,
                image: pro.images[0],
                discount: pro.discount || 0,
                rating: pro.rating,
                slug: pro.slug
            }));
        }
    }

    return (
      <>
          {products.length === 0 ? (
         <div className="text-center text-gray-700 font-semibold py-6">
         No products found.
         <Link to="/products">
             <Button className="m-2">
                 Browse Other Products
             </Button>
         </Link>
     </div>
     
          ) : (
              <div className={` ${
                  styles === 'grid' ? 'grid-cols-3 md-lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-1 grid' 
                  : 'w-[400px] md-lg:w-auto grid-cols-3 md-lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1'} gap-3`
              }>
                  {products.map((p, i) => (
                      <div
                          key={i}
                          className="bg-white border border-gray-100 group transition-all duration-500 hover:shadow-md cursor-pointer"
                      >
                          <div className="relative overflow-hidden">
                              {p.sellerInfo?.isTopSeller && (
                                  <div className="flex justify-center items-center absolute text-black py-[2px] px-3 rounded-full bg-yellow-400 font-semibold text-xs left-2 bottom-2 z-10">
                                      <Trophy size={12} className="mr-1" /> Top Seller
                                  </div>
                              )}
                              {p.discount ? (
                                  <div className="flex justify-center items-center absolute text-white py-[2px] px-6 rounded-full bg-red-600 font-semibold text-s left-2 top-2">
                                      {p.discount}%
                                  </div>
                              ) : ("")}
                              <Link to={`/product/details/${p._id}`} className="">
                                  <img
                                      className="sm:w-full w-full h-[240px] nex_img_cover"
                                      src={p.images[0]}
                                      alt="product image"
                                  />
                              </Link>
                          </div>
                          <div className="py-3 text-slate-white px-2">
                              <div className="flex justify-between items-center gap-3 p-2">
                                  <h2>{p.name} ({p.stock})</h2>
                                  <span className="text-lg font-bold">{formatCurrency(p.price, currencyCode, exchangeLoaded)}</span>
                              </div>
                              <div className="p-2 flex flex-row items-center justify-between gap-2">
                                  <div className="text-sm text-gray-400 truncate">{p.brand}</div>
                                  <Link to={`/stores/${p.shopName}/${p.sellerId}`} className="flex items-center text-gray-700 nex_badge text-sm truncate max-w-full">
                                      By {p.shopName || 'Unknown Shop'}
                                  </Link>
                              </div>
                              <div className="gap-3 p-2">
                                  <div className="flex items-center justify-between mb-4">
                                      <div className="flex">
                                          <Ratings ratings={p.rating} />
                                      </div>
                                      <Heart
                                          onClick={() => toggle_wishlist(p)}
                                          size={24}
                                          className={`cursor-pointer transition-colors ${wishlist.find(w => w.productId === p._id.toString() || w.productId === p._id) ? 'fill-red-500 text-red-500' : 'text-gray-400 hover:text-red-400'}`}
                                      />
                                  </div>
                                  {(() => {
                                      const inCart = cart_product_ids.includes(p._id?.toString());
                                      return (
                                          <button
                                              onClick={() => toggle_cart(p)}
                                              className={`w-full justify-center flex items-center font-semibold border transition-colors nex_button_main ${inCart ? 'bg-green-50 border-green-400 text-green-700 hover:bg-red-50 hover:border-red-400 hover:text-red-600' : 'border-gray-200 hover:bg-[#FFE11B] hover:border-[#FFE11B] hover:text-black'}`}
                                          >
                                              {inCart ? <>In Cart ✓ <ShoppingBag className="ml-2" size={20} /></> : <>Add to cart <ShoppingBag className="ml-2" size={24} /></>}
                                          </button>
                                      );
                                  })()}
                              </div>
                          </div>
                      </div>
                  ))}
              </div>
          )}
      </>
  );
  
}

export default ShopProducts